$(document).ready(function(){
  $homepageSlider = $('.full-image-slider .slick');
  
  if ($homepageSlider.length) {
    slickInit($homepageSlider, true, false);

    // Get the iframe based on the slide id
    var videoGet   = function( id ) {
      var video = $( '#video-container-' + id );
          video = video.find('iframe')[0];
      return video;
    }

    // Start video based on iframe id and animate container
    var videoStart = function( video ) {
      // Show video
      $( video ).parent().addClass( "video-open" );
      $homepageSlider.parent().addClass( "video-open" );
      // Add autoplay to src
      video.contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
      // Stop Slick from autoplayng
      $homepageSlider.slick('slickPause');
    }

    // Stop video based on iframe id and animate container
    var videoStop  = function( video ) {
      // Hide video
      $( video ).parent().removeClass( "video-open" );
      $homepageSlider.parent().removeClass( "video-open" );
      // Remove autoplay from src
      video.contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
      // Allow Slick to autoplay
      $homepageSlider.slick('slickPlay');
    }

    var videoStopAll = function() {
      // Stop all youtube plays. Warning, this is executed once per video
      // regardless of play state.
      $('.youtube_player_iframe').each( function(){
        videoStop( this );
      });
    }

    $('.slide-videos-container').on('click', function(e) {
      videoStopAll();
    });

    $('.btn-rounded.video').on('click', function(e) {
      videoStart( videoGet( $(this).data('target-id') ) );
    });

    $homepageSlider.on('afterChange', function( event, slick, currentSlide, nextSlide ){
      // Stop all youtube plays
      videoStopAll();
    });
  };
});